import r from"styled-components";import{DateButtonType as o}from"./DatePickerWrapper.js";const e=r.div`
	display: flex;
	padding: 5px 8px;
	background: ${r=>r.bgColor};
	border-width: 1px;
	border-style: solid;
	border-color: ${r=>r.borderColor};
	border-radius: 4px;
	flex-direction: row;
	align-items: center;
	gap: 8px;
	position: relative;
	height: ${r=>r.dateButtonType===o.LARGE?"48px":"32px"};
`,a=r.div`
	position: absolute;
	top: calc(100% + 8px);
	zindex: 9;
	.custom__calendar {
		background: ${r=>r.bgColor};
		border-width: 1px;
		border-style: solid;
		border-color: ${r=>r.borderColor};
		box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.12);
		border-radius: 4px;
	}

	.custom__tile:hover,
	.custom__tile:focus,
	.react-calendar__tile--active {
		background: ${r=>r.brandColor};
	}

	.react-calendar__month-view__weekdays__weekday {
		font-family: 'Inter';
		font-style: normal;
		overflow: hidden;
		font-weight: 600;
		font-size: 14px;
		line-height: 20px;
		color: ${r=>r.contentPrimary};

		abbr[title] {
			text-decoration: none !important;
		}
	}

	.react-calendar__month-view__weekdays {
		background: ${r=>r.subDued};
	}

	.react-calendar__navigation {
		display: flex;
		padding: 12px 20px;

		button {
			border: 0;
			background: transparent;
		}

		.react-calendar__navigation__arrow
			react-calendar__navigation__prev2-button {
			font-size: 20px;
		}

		.react-calendar__navigation__arrow react-calendar__navigation__prev-button {
			font-size: 20px;
		}
	}
`;export{e as DateBtn,a as PickerContainer};
